import { StackClientApp } from "@stackframe/react";

export const stackClientApp = new StackClientApp({
  projectId: import.meta.env.VITE_STACK_AUTH_PROJECT_ID ?? "7afcc865-0b99-4511-ba5a-6cc45c46e22e",
  publishableClientKey: import.meta.env.VITE_STACK_AUTH_PUBLISHABLE_KEY ?? "pck_ywd17fne3e19mpjaa5vfzkzkts02w4918eazsqm5cp5y8",
  // Cookie store is required for OAuth flows — the browser redirects away to the
  // OAuth provider and back, so tokens must persist across page navigations.
  // Edge tracking prevention warnings about api.stack-auth.com are cosmetic and
  // don't affect first-party cookies on our own domain.
  tokenStore: "cookie",
  urls: {
    signIn: "/login",
    afterSignIn: "/",
    signUp: "/login",
    afterSignUp: "/",
    signOut: "/login",
    afterSignOut: "/login",
  },
});
